<div id="wizardService.agents.overview">
    <div class="label">Proxy settings</div>
    <br />
    <proxy-settings
      [parent]="'agent'"
      [key]="'webProxy'"
      [parentOutput]="step.parent.output"
      (onUpdate)="step.makeValueForAgentProxy('webProxy', $event.key, $event.value, $event.isValid)">
      </proxy-settings>
  
  </div>